module.exports = {"kid":"Kid (0-4 years old)","young":"Young (5-13 years old)","adult":"Adult"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/tabs.json
// module id = HrSN
// module chunks = 16